import {
  AFFILIATE_LOCALES,
  AFFILIATE_NAMESPACES,
  LOCALE_LABELS,
  createI18nConfig,
  supportedLocales,
  useTranslation,
  type AffiliateContent,
  type SupportedLocale,
} from "@cronika/locales";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export { useTranslation } from "@cronika/locales";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...createI18nConfig({
      locales: AFFILIATE_LOCALES,
      namespaces: AFFILIATE_NAMESPACES,
      defaultNS: "affiliate:common",
      fallbackLng: "en",
    }),
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator"],
      lookupCookie: "locale",
      lookupLocalStorage: "locale",
      caches: ["cookie", "localStorage"],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

function syncHtmlLang(lng: string) {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng.split("-")[0] ?? lng;
  }
}
i18n.on("languageChanged", syncHtmlLang);
syncHtmlLang(i18n.language ?? "en");

const AFFILIATE_UI_LOCALES = ["ru", "en", "es", "pt", "ua"] as const;

export const languages = AFFILIATE_UI_LOCALES.map((code) => ({
  code,
  label: code.toUpperCase(),
  name: LOCALE_LABELS[code],
}));

export function useContent(): AffiliateContent {
  const { i18n: instance } = useTranslation("affiliate:common");
  const lng = (instance.language?.split("-")[0] ?? "en") as SupportedLocale;
  const bundle =
    instance.getResourceBundle(lng, "affiliate:common") ??
    instance.getResourceBundle("en", "affiliate:common");
  return bundle as AffiliateContent;
}

export default i18n;
